import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist used ONLY by the "Unique" validator on the Enterprise Term Revision Name
// field. The validator queries this EC where typeValue (= "Name") equals the entered value; any
// match means the name is already taken. The EnterpriseTermRevision EC query is realm-scoped
// server-side, so uniqueness is enforced within the tenant. (A term's revisions all share its
// Name, but the Unique validator only fires when the value CHANGES, so an unchanged edit is fine.)
class EnterpriseTermRevisionNameUniquePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "EnterpriseTermRevisionNameUnique";
        this.static = false;
        this.enterpriseComponent = "EnterpriseTermRevision";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.typeField = "Name";
        this.typeValue = "Name";
        this.allowNoSelection = false;
    }
}

export default EnterpriseTermRevisionNameUniquePicklistMetadata;
